import { MapPrintPreviewDrawer as View } from "ui-components";

export const MapPrintPreviewDrawer = () => {
	return <View />;
};
